import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconScaleSmall24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconScaleSmall24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M16 8.5h-4.5v7H16zm1.5 0v7h2a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1zm-13 0H10v7H4.5a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1m0-1.5A2.5 2.5 0 0 0 2 9.5v5A2.5 2.5 0 0 0 4.5 17h15a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 19.5 7z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconScaleSmall24);
